import { gameActionTypes } from './constants';
import { EndOutcome, GameData } from '../types';

export function getGameDataRequest() {
	return {
		type: gameActionTypes.GET_GAME_DATA_REQUEST,
	};
}

export function getGameDataSuccess(gameData: GameData) {
	return {
		type: gameActionTypes.GET_GAME_DATA_SUCCESS,
		payload: { gameData },
	};
}

export function getGameDataError() {
	return {
		type: gameActionTypes.GET_GAME_DATA_ERROR,
	};
}

export function clearGameState() {
	return {
		type: gameActionTypes.CLEAR_GAME_STATE,
	};
}

export function finishGameRequest(
	gameDataId?: number | string,
	freePlayCategoryId?: number | string,
	gameOutcome?: EndOutcome,
	score?: number,
	data?: Record<string, unknown>,
) {
	return {
		type: gameActionTypes.FINISH_GAME_REQUEST,
		payload: { gameDataId, freePlayCategoryId, gameOutcome, score, data },
	};
}

export function finishGameSuccess() {
	return {
		type: gameActionTypes.FINISH_GAME_SUCCESS,
	};
}

export function finishGameError() {
	return {
		type: gameActionTypes.FINISH_GAME_ERROR,
	};
}

export function setCurrentLevel(currentLevel: any) {
	return {
		type: gameActionTypes.SET_CURRENT_LEVEL,
		payload: { currentLevel },
	};
}
